import styled from 'styled-components';

export const StyledBalancesLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 4px;
  font-weight: 700;

  .balanceLayoutContainer {
    align-items: center;
    flex: 1;
    max-width: calc(100% - 16px);
    width: 100%;
    display: flex;

    @media only screen and (max-width: 767px) {
      flex-wrap: wrap;
    }
  }

  &.pipa,
  &.bagelcode {
    .balanceLayoutContainer {
      max-width: max-content;
    }
  }
`;
